import React, { useEffect } from 'react';
import Cookies from "universal-cookie";
import moment from 'moment';
import axios from "../../axios"
import {USERSESSION } from "../../redux/CommonInitialsate";
import { useSelector, useDispatch } from "react-redux";

export default function Usersessionaudit() {
  const userid = localStorage.getItem("userid") == undefined ? "" : JSON.parse(localStorage.getItem("userid"));
  const email = localStorage.getItem("email") == undefined ? "" : JSON.parse(localStorage.getItem("email"));
  const rolecode = localStorage.getItem("Rolecode") == "undefined" ? "" : JSON.parse(localStorage.getItem("Rolecode"));
  let smrole = localStorage.getItem("ProjectRole");
  let empid = JSON.parse(localStorage.getItem("Empdetails"));
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const { projectRole, } = useSelector((state) => state.user)
  const getCookie = (cookieName) => {
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return null;
  };
  
  const token = getCookie('token');
  const company = empid?.[0]?.ClientDetails?.Company?.replace(/ /g, "");

  let tenantid = `devozy_${company}_${empid?.[0]?.ClientId}`;

  const userAgent = navigator.userAgent;
  let browserName = navigator.appName;
  let fullVersion = '' + parseFloat(navigator.appVersion);

  if (userAgent.indexOf("Edg") !== -1) {
    browserName = "Microsoft Edge";
    const versionMatch = userAgent.match(/Edg\/(\d+\.\d+)/);
    if (versionMatch) {
      fullVersion = versionMatch[1];
    }
  } else if (userAgent.indexOf("Chrome") !== -1) {
    browserName = "Google Chrome";
    const versionMatch = userAgent.match(/Chrome\/(\d+\.\d+)/);
    if (versionMatch) {
      fullVersion = versionMatch[1];
    }
  } else if (userAgent.indexOf("Firefox") !== -1) {
    browserName = "Mozilla Firefox";
    const versionMatch = userAgent.match(/Firefox\/(\d+\.\d+)/);
    if (versionMatch) {
      fullVersion = versionMatch[1];
    }
  } else if (userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1) {
    browserName = "Apple Safari";
    const versionMatch = userAgent.match(/Version\/(\d+\.\d+)/);
    if (versionMatch) {
      fullVersion = versionMatch[1];
    }
  } else {
    const versionMatch = userAgent.match(/Version\/(\d+\.\d+)/);
    if (versionMatch) {
      fullVersion = versionMatch[1];
    }
  }

  let postsession = {
    UserDetails: {
      UserId: userid,
      UUID: empid?.[0]?.UUID,
      email: email,
      role:  smrole  || rolecode ,
    },
    OrgDetails: {
      ClientId: empid?.[0]?.ClientId,
      Company: empid?.[0]?.ClientDetails.Company,
      Country: "USA",
      TentantId: tenantid,
    },
    AppDetails: {
      AppId: "1",
      AppName: "AgilePM",
    },
    DeviceDetails: {
      SessionType: "web",
      browser: browserName,
      browser_version: fullVersion,
    },
    LoginToken: token,
    IsSessionAlive: "Y",
    LoggedInTime: moment().format('YYYY-MM-DD THH:mm:ss'),
    LoggedOutTime: null,
    HoursLogged: 0,
    NoofPagesVisited: null,
    NoofActions: null,
    IsActive: null,
    Status: null,
  };
console.log(postsession,"postddwsd");


  const postSessionData = async () => {
    try {
      const response = await axios.post(
        'subscription_user_session_audit',
        postsession, 
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + cookies.get("token"),
            Prefer: "return=representation", 
          },
        }
      );


      if (response.status === 201) {
        console.log('Session audit posted:', response.data);
        const userSessionId = response.data?.[0]?.UserSessionId;
        console.log(userSessionId,"usersss");
        dispatch(
          USERSESSION(
         userSessionId
          )
        );
        localStorage.setItem("sessionAuditPosted", true);
        localStorage.setItem("LoggedInTime", postsession.LoggedInTime);
      } else {
        console.error('Failed to post session audit, status code:', response.status);
      }
    } catch (error) {
      console.error('Error posting session data:', error);
    }
  };

  useEffect(() => {
    const sessionAuditPosted = localStorage.getItem("sessionAuditPosted");

   
    if (!sessionAuditPosted && userid && token) {
      postSessionData();
    }
  }, [userid, token]);

}
